import { Component } from '@angular/core';

@Component({
  selector: 'app-form-input-file-list',
  templateUrl: './form-input-file-list.component.html',
  styleUrls: ['./form-input-file-list.component.sass']
})
export class FormInputFileListComponent {

}
